/**
 * ss-core.js — Smoke Shop runtime helpers (owned, not Dawn).
 * Quantity stepper, debounce, JSON fetch config, focus trap.
 */
(function () {
  'use strict';

  function getFocusableElements(container) {
    if (!container || !container.querySelectorAll) return [];
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), input:not([type="hidden"]):enabled, select:enabled, textarea:enabled'
      )
    );
  }

  var trapFocusHandlers = {};

  function trapFocus(container, elementToFocus) {
    if (!container) return;
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    elementToFocus = elementToFocus || container;

    removeTrapFocus();

    trapFocusHandlers.focusin = function (event) {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        if (first) first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        if (last) last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    if (elementToFocus && typeof elementToFocus.focus === 'function') elementToFocus.focus();
  }

  function removeTrapFocus(elementToFocus) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus && typeof elementToFocus.focus === 'function') elementToFocus.focus();
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function fetchConfig(type) {
    type = type || 'json';
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/' + type }
    };
  }

  if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('input');
          this.changeEvent = new Event('change', { bubbles: true });
          this.querySelectorAll('button').forEach(
            function (button) {
              button.addEventListener('click', this.onButtonClick.bind(this));
            }.bind(this)
          );
        }
        onButtonClick(event) {
          event.preventDefault();
          if (!this.input) return;
          var previousValue = this.input.value;
          var button = event.target.closest('button');
          if (!button) return;
          if (button.name === 'plus') this.input.stepUp();
          else this.input.stepDown();
          if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        }
      }
    );
  }

  window.trapFocus = trapFocus;
  window.removeTrapFocus = removeTrapFocus;
  window.debounce = debounce;
  window.fetchConfig = fetchConfig;
})();
